import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ToastService } from '../toast.service';

@Component({
  selector: 'app-document-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
<div class="modal-backdrop" (click)="onClose()"></div>

<div class="modal">
  <div class="modal-header">
    <h2>KYC Documents — {{ distributorName }}</h2>
    <span class="icon-btn" (click)="onClose()">
      <i class="fas fa-times"></i>
    </span>
  </div>

  <div class="modal-body">
    <div *ngIf="isLoading" class="loading-state">
      <i class="fas fa-spinner fa-spin"></i> Loading documents...
    </div>

    <div *ngIf="!isLoading">
      <!-- Aadhaar Section -->
      <div class="doc-card">
        <div class="doc-card-header">
          <div class="doc-icon aadhaar">
            <i class="fas fa-id-card"></i>
          </div>
          <div class="doc-info">
            <span class="doc-label">Aadhaar Card</span>
            <span class="doc-badge uploaded" *ngIf="hasAadhaar">
              <i class="fas fa-check-circle"></i> Uploaded
            </span>
            <span class="doc-badge missing" *ngIf="!hasAadhaar">
              <i class="fas fa-exclamation-circle"></i> Not uploaded
            </span>
          </div>
          <a *ngIf="hasAadhaar && aadhaarUrl" [href]="aadhaarUrl" target="_blank" class="btn small secondary">
            <i class="fas fa-external-link-alt"></i> View
          </a>
        </div>
        <div class="upload-area">
          <label class="file-label">
            <i class="fas fa-upload"></i>
            {{ aadhaarFile ? aadhaarFile.name : (hasAadhaar ? 'Replace Aadhaar' : 'Upload Aadhaar') }}
            <input type="file" (change)="onFileChange($event, 'aadhaar')" accept=".pdf,.png,.jpg,.jpeg" style="display:none" />
          </label>
        </div>
      </div>

      <!-- PAN Section -->
      <div class="doc-card">
        <div class="doc-card-header">
          <div class="doc-icon pan">
            <i class="fas fa-file-invoice"></i>
          </div>
          <div class="doc-info">
            <span class="doc-label">PAN Card</span>
            <span class="doc-badge uploaded" *ngIf="hasPan">
              <i class="fas fa-check-circle"></i> Uploaded
            </span>
            <span class="doc-badge missing" *ngIf="!hasPan">
              <i class="fas fa-exclamation-circle"></i> Not uploaded
            </span>
          </div>
          <a *ngIf="hasPan && panUrl" [href]="panUrl" target="_blank" class="btn small secondary">
            <i class="fas fa-external-link-alt"></i> View
          </a>
        </div>
        <div class="upload-area">
          <label class="file-label">
            <i class="fas fa-upload"></i>
            {{ panFile ? panFile.name : (hasPan ? 'Replace PAN' : 'Upload PAN') }}
            <input type="file" (change)="onFileChange($event, 'pan')" accept=".pdf,.png,.jpg,.jpeg" style="display:none" />
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer" *ngIf="!isLoading">
    <button class="btn secondary" type="button" (click)="onClose()">Cancel</button>
    <button class="btn primary" type="button" (click)="onSubmit()"
      [disabled]="isSubmitting || (!aadhaarFile && !panFile)">
      <i class="fas fa-cloud-upload-alt" *ngIf="!isSubmitting"></i>
      <i class="fas fa-spinner fa-spin" *ngIf="isSubmitting"></i>
      {{ isSubmitting ? 'Uploading...' : 'Upload' }}
    </button>
  </div>
</div>
  `,
  styles: [`
.modal-backdrop {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.4); backdrop-filter: blur(4px); z-index: 1000;
}
.modal {
  position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
  background: white; border-radius: 12px; width: 480px; max-width: 90vw;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15); z-index: 1001;
  display: flex; flex-direction: column; max-height: 90vh;
}
.modal-header {
  padding: 20px 24px; border-bottom: 1px solid #e2e8f0;
  display: flex; justify-content: space-between; align-items: center;
}
.modal-header h2 { margin: 0; font-size: 1.1rem; font-weight: 600; color: #1e293b; }
.icon-btn { cursor: pointer; color: #64748b; font-size: 1.2rem; }
.icon-btn:hover { color: #0f172a; }
.modal-body { padding: 24px; overflow-y: auto; display: flex; flex-direction: column; gap: 16px; }
.loading-state { text-align: center; padding: 30px; color: #64748b; }

.doc-card {
  border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden;
  background: white; box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}
.doc-card-header {
  display: flex; align-items: center; gap: 12px; padding: 14px 16px;
  background: #f8fafc;
}
.doc-icon {
  width: 38px; height: 38px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem; flex-shrink: 0;
}
.doc-icon.aadhaar { background: #eff6ff; color: #3b82f6; }
.doc-icon.pan { background: #fef3c7; color: #d97706; }
.doc-info { flex: 1; display: flex; flex-direction: column; gap: 2px; }
.doc-label { font-size: 0.9rem; font-weight: 600; color: #1e293b; }
.doc-badge {
  display: inline-flex; align-items: center; gap: 4px;
  font-size: 0.72rem; font-weight: 600; padding: 2px 8px;
  border-radius: 12px; width: fit-content;
}
.doc-badge.uploaded { background: #ecfdf5; color: #059669; border: 1px solid #a7f3d0; }
.doc-badge.missing { background: #fef9c3; color: #854d0e; border: 1px solid #fde047; }

.upload-area { padding: 10px 16px; border-top: 1px solid #e2e8f0; }
.file-label {
  display: flex; align-items: center; gap: 8px; cursor: pointer;
  font-size: 0.85rem; color: #475569; padding: 8px 12px;
  border: 1px dashed #cbd5e1; border-radius: 6px;
  transition: all 0.2s; background: #f8fafc;
}
.file-label:hover { border-color: #94a3b8; background: #f1f5f9; color: #0f172a; }
.file-label i { color: #94a3b8; font-size: 0.9rem; }

.modal-footer {
  padding: 16px 24px; border-top: 1px solid #e2e8f0;
  display: flex; justify-content: flex-end; gap: 12px;
}
.btn { padding: 8px 16px; border-radius: 6px; cursor: pointer; font-weight: 500; font-size: 0.9rem; transition: background 0.2s; display: inline-flex; align-items: center; gap: 6px; }
.btn.small { padding: 5px 10px; font-size: 0.8rem; }
.btn.secondary { background: white; border: 1px solid #cbd5e1; color: #475569; }
.btn.secondary:hover:not(:disabled) { background: #f8fafc; }
.btn.primary { background: #0f172a; border: none; color: white; }
.btn.primary:hover:not(:disabled) { background: #1e293b; }
.btn:disabled { opacity: 0.65; cursor: not-allowed; }
  `]
})
export class DocumentModalComponent implements OnInit {
  @Input() distributorId: string | undefined;
  @Input() distributorName: string | undefined;
  @Output() close = new EventEmitter<void>();
  @Output() saved = new EventEmitter<void>();

  isLoading = true;
  isSubmitting = false;

  aadhaarUrl: string | null = null;
  panUrl: string | null = null;
  hasAadhaar = false;
  hasPan = false;

  aadhaarFile: File | null = null;
  panFile: File | null = null;

  constructor(private http: HttpClient, private toastService: ToastService) {}

  ngOnInit() {
    if (this.distributorId) {
      this.fetchDocuments();
    }
  }

  fetchDocuments() {
    this.isLoading = true;
    this.http.get<any>(`${environment.apiBaseUrl}/admin/distributor/${this.distributorId}/documents`).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.statusCode === 200 && res.data) {
          this.aadhaarUrl = res.data.aadhaar_url;
          this.panUrl = res.data.pan_url;
          this.hasAadhaar = res.data.has_aadhaar;
          this.hasPan = res.data.has_pan;
        }
      },
      error: () => {
        this.isLoading = false;
        this.toastService.error('Failed to fetch documents');
      }
    });
  }

  onFileChange(event: any, type: 'aadhaar' | 'pan') {
    const file = event.target.files[0];
    if (file) {
      if (type === 'aadhaar') this.aadhaarFile = file;
      else this.panFile = file;
    }
  }

  onSubmit() {
    if (!this.aadhaarFile && !this.panFile) {
      this.toastService.error('Please select at least one document to upload');
      return;
    }
    this.isSubmitting = true;
    const formData = new FormData();
    if (this.aadhaarFile) formData.append('aadhaar', this.aadhaarFile);
    if (this.panFile) formData.append('pan', this.panFile);

    this.http.post<any>(`${environment.apiBaseUrl}/admin/distributor/${this.distributorId}/documents`, formData).subscribe({
      next: (res) => {
        this.isSubmitting = false;
        if (res.statusCode === 200) {
          this.toastService.success('Documents uploaded successfully');
          this.aadhaarFile = null;
          this.panFile = null;
          this.fetchDocuments();
          this.saved.emit();
        } else {
          this.toastService.error(res.message || 'Failed to upload documents');
        }
      },
      error: (err) => {
        this.isSubmitting = false;
        this.toastService.error(err?.error?.message || 'Failed to upload documents');
      }
    });
  }

  onClose() {
    this.close.emit();
  }
}
